import { mergeFilter, slugToFilter } from '@plugin/searchRoute/modules/house'
import { cloneDeep } from 'lodash-es'
import { useMemo } from 'react'

/**
 * 把route上的参数转成houses/filter接口需要的参数
 * { "suburbId": "1142", "typeId": 1, "offset": 0, "limit": 40, "price": "1000000+" }
 * 转成
 * query: { "suburbId": "1142", "typeId": 1 }
 * filter: "bern_2,5_barn_1,5_prn_21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42"
 * @param {object} filterMeta houses/filter/meta
 * @param {object} state { slug, type, pageSize, searchParams }
 * @returns [filter, query, data]
 */
export default function useParamsToFilter({
  state,
  filterMeta
}) {
  const [filter, query] = useMemo(() => slugToFilter(state.slug, filterMeta, state.type), [state, filterMeta])
  const baseData = useMemo(() => cloneDeep(filterMeta), [filterMeta])

  return [
    mergeFilter(filter, state.searchParams.filter),
    query,
    baseData
  ]
}
